<!-- Header -->
<div mat-dialog-title
	role="heading"
	style="text-align: center; color: #A20000;"
	translate>
	Errors Exist
</div>

<!-- Body -->
<mat-dialog-content>
	<div translate>
		The query being imported contains the following fields that do not exist in the database:
	</div>
	<ul style="margin-top: 10px; margin-bottom: 10px; align-self: center;">
		<li *ngFor="let field of fields">
			{{field.Alias ? field.Alias : field.FieldName}}
		</li>
	</ul>
	<div translate>
		These fields will need to be removed or corrected before results can be displayed.
	</div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Right Buttons -->
	<div class="flex-footer-right">
		<tyl-button image="Cancel.png"
			label="Close"
			(clickEvent)="close()"></tyl-button>
	</div>
</mat-dialog-actions>